import React from "react";
import {
  KanbanComponent,
  ColumnsDirective,
  ColumnDirective,
} from "@syncfusion/ej2-react-kanban";

import { kanbanData, kanbanGrid } from "../data/dummy";
import { Header } from "../components";
const Kanban = () => {
  return (
    <div className="m-2 mt-24 bg-white p-2 md:p-10 rounded-3xl">
      <Header category="Page" title="Kanban" />
      <KanbanComponent dataSource={kanbanData} id='kanban' keyField="Status" cardSettings={{contentField:'Summary', headerField:'Id'}}>
        <ColumnsDirective>
          {kanbanGrid.map((item, index) => (
            <ColumnDirective key={index} {...item} />
          ))}
        </ColumnsDirective>
        {/* <Inject services={[]} /> */}
      </KanbanComponent>
    </div>
  );
};

export default Kanban;
